import { render, staticRenderFns } from "./AddBaby.vue?vue&type=template&id=549e2d4a&scoped=true"
import script from "./AddBaby.vue?vue&type=script&lang=js"
export * from "./AddBaby.vue?vue&type=script&lang=js"
import style0 from "./AddBaby.vue?vue&type=style&index=0&id=549e2d4a&prod&lang=scss&scoped=true"
import style1 from "./AddBaby.vue?vue&type=style&index=1&id=549e2d4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549e2d4a",
  null
  
)

export default component.exports